<template>
  <div>
    <div class="card">
      <div class="card-block">
        <div class="mapContainer">
          <div id="activityMap"></div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState } from 'vuex';

export default {
  name: 'ActivityMap',
  components: {
  },
  data() {
    return {
      map: undefined,
      circle: undefined,
    };
  },
  computed: {
    ...mapState({
      language: state => state.language,
      activity: state => state.activityPublic.activity,
    }),
    coordinatesChange() {
      return {
        latitude: this.$store.state.activityPublic.activity.latitude || 0,
        longitude: this.$store.state.activityPublic.activity.longitude || 0,
      };
    },
  },
  watch: {
    coordinatesChange(value) {
      if (typeof value !== 'undefined') {
        if (typeof value.latitude !== 'undefined' && typeof value.longitude !== 'undefined') {
          this.setMarker(value.latitude, value.longitude);
        }
      }
    },
  },
  mounted() {
    const coords = {
      lat: 39,
      lng: -8,
    };
    const self = this;
    function waitForGoogle() {
      if (typeof google !== 'undefined') {
        self.loaded = true;
        self.map = new window.google.maps.Map(document.getElementById('activityMap'), {
          zoom: 4,
          center: coords,
          scrollwheel: false,
        });
        if (typeof self.markerLatitude !== 'undefined'
          && typeof self.markerLongitude !== 'undefined') {
          self.setMarker(self.markerLatitude, self.markerLongitude);
        }

        self.map = new window.google.maps.Map(document.getElementById('activityMap'), {
          zoom: 9,
          center: coords,
          scrollwheel: false,
        });
        if (typeof self.markerLatitude !== 'undefined'
           && typeof self.markerLongitude !== 'undefined') {
          self.setMarker(self.markerLatitude, self.markerLongitude);
        }
        self.createCircle(self.activity.latitude, self.activity.longitude);
      } else {
        setTimeout(waitForGoogle, 500);
      }
    }
    waitForGoogle();
  },
  beforeCreate() {
    if (typeof window.google === 'undefined') {
      const s1 = document.createElement('script');
      const s0 = document.getElementsByTagName('script')[0];
      s1.id = 'googleMaps';
      s1.async = true;
      s1.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDeskUQ3JvQqQqyxaUvZFXi-VJuyMpESak';
      s1.charset = 'UTF-8';
      s0.parentNode.insertBefore(s1, s0);
    }
  },
  methods: {
    createCircle(lat, lng) {
      const latitude = parseFloat(lat);
      const longitude = parseFloat(lng);
      if (!isNaN(latitude) && !isNaN(longitude)) {
        if (typeof window.google !== 'undefined') {
          if (latitude <= 180 && latitude >= -180 && longitude <= 180 && longitude >= -180) {
            this.circle = new window.google.maps.Circle({
              strokeColor: '#00B48D',
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: '#00B48D',
              fillOpacity: 0.35,
              map: this.map,
              center: { lat: latitude, lng: longitude },
              radius: 8000,
            });
            if (typeof this.map !== 'undefined') {
              this.map.setCenter({ lat: latitude, lng: longitude });
            }
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mapContainer {
  padding-top: 50%; // map height as a percentage of width;
}
#activityMap {
  position: absolute;
  top: 15px; left: 15px;;
  width: calc(100% - 30px); height: calc(100% - 30px;);
}
.card-block {
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// ActivityMap.vue?12e4a9b8